import React from 'react';
import { Tooltip } from 'antd';

/**
 * Universal component of tooltip with information icon
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.title - Text or content of tooltip
 * @param {string} props.color - Background color of tooltip (optional)
 * @param {Object} props.tooltipProps - Additional properties for Tooltip component
 * @param {Object} props.iconProps - Additional properties for icon
 * @param {string} props.className - Additional classes for container
 * @returns {JSX.Element} InfoTooltip component
 */
const InfoTooltip = ({
  title,
  color = 'rgba(0, 0, 0, 0.85)',
  tooltipProps = {placement: 'right'},
  iconProps = {},
  className = '',
}) => {
  const defaultIconProps = {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      border: '2px solid #BBBBBB',
      color: '#333',
      fontSize: '12px',
      fontWeight: 'bold',
      fontStyle: 'normal',
      cursor: 'pointer',
      ...iconProps.style
    }
  };

  const mergedIconProps = {
    ...defaultIconProps,
    ...iconProps
  };

  return (
    <Tooltip
      title={title}
      color={color}
      {...tooltipProps}
    >
      <span className={`info-tooltip-icon ${className}`} {...mergedIconProps}>i</span>
    </Tooltip>
  );
};

export default InfoTooltip;
